import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 583.000000 1080.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)">

<path d="M1579 7976 c-40 -21 -151 -82 -319 -176 -229 -128 -418 -233 -480
-267 -106 -57 -336 -186 -412 -230 l-78 -45 0 -728 0 -728 158 -88 c86 -48
200 -111 252 -140 96 -53 290 -161 683 -379 l216 -120 1 -730 0 -730 108 -59
c59 -33 136 -76 172 -96 123 -70 245 -138 295 -164 28 -15 57 -31 65 -37 8 -5
67 -38 130 -72 173 -96 211 -117 385 -215 l160 -90 55 31 c30 16 71 39 90 50
149 82 129 60 225 250 48 94 118 231 155 302 37 72 143 281 236 465 93 184
171 337 174 340 10 10 70 136 70 147 0 6 4 13 9 15 4 2 59 104 121 228 63 124
122 242 133 263 11 21 17 40 14 43 -3 3 -49 -68 -103 -158 -53 -90 -114 -189
-136 -220 -21 -31 -38 -59 -38 -61 0 -3 -25 -45 -55 -93 -31 -49 -61 -98 -68
-109 -7 -11 -15 -22 -18 -25 -3 -3 -9 -12 -13 -20 -3 -8 -4 -2 0 14 3 17 14
37 24 46 11 10 17 20 14 23 -4 3 -12 1 -18 -6 -19 -18 -186 -10 -186 9 0 11
-17 14 -80 14 -47 0 -80 4 -80 10 0 6 -33 10 -80 10 -64 0 -80 3 -80 15 0 8
-6 15 -12 15 -7 1 -2 10 11 20 31 26 17 26 -20 -1 -16 -11 -38 -19 -49 -17
-14 2 16 23 96 68 64 36 122 70 128 75 7 6 38 24 71 41 33 17 104 56 157 87
54 32 100 57 102 57 3 0 31 15 63 34 74 43 341 195 371 211 26 14 42 3 -178
125 -47 26 -146 81 -220 122 -74 41 -166 92 -205 113 -38 21 -122 67 -185 103
-284 159 -405 222 -429 222 -11 0 -21 6 -21 14 0 8 -6 16 -14 19 -9 4 -16 -5
-21 -26 -3 -18 -9 -336 -12 -707 -3 -371 -7 -677 -9 -679 -4 -4 -96 40 -104
50 -3 4 -30 19 -60 34 -30 15 -66 35 -80 45 -14 9 -61 36 -105 59 -44 23 -96
52 -115 63 -19 11 -62 35 -95 53 -33 18 -89 49 -125 69 -36 20 -81 44 -100 54
-19 9 -37 19 -40 22 -8 9 -255 147 -397 222 -35 18 -63 36 -63 41 0 4 10 12
23 17 12 6 29 14 37 20 8 5 119 66 245 136 127 69 250 138 275 152 126 71 184
102 191 102 5 0 9 4 9 8 0 4 12 13 28 19 28 12 154 80 207 113 17 10 55 31 85
48 69 37 150 82 173 96 16 10 17 57 17 747 l0 735 -32 17 c-18 9 -64 34 -103
55 -83 46 -415 231 -465 259 -19 11 -123 68 -230 128 -107 59 -224 124 -260
145 -195 112 -214 120 -241 106z m-777 -1297 c78 -42 49 -214 -48 -282 -75
-53 -189 -47 -234 11 -50 62 -4 200 86 258 49 33 147 39 196 13z m1880 -2 c37
-23 36 -49 -7 -201 -9 -32 -14 -69 -11 -82 5 -18 1 -23 -22 -28 -38 -9 -132
-5 -138 6 -3 4 4 20 15 34 32 41 27 56 -16 52 -36 -3 -38 -5 -41 -43 -2 -22
-9 -43 -15 -47 -17 -11 -79 -9 -97 2 -13 9 -10 15 17 38 18 16 54 73 86 138
30 60 62 116 70 123 38 31 115 35 159 8z m-1632 -1 c0 -7 -6 -19 -14 -25 -15
-12 -30 -60 -22 -68 2 -3 17 7 33 20 15 14 44 39 63 56 55 48 110 38 110 -20
0 -36 -23 -53 -64 -46 -20 3 -41 0 -52 -7 -16 -12 -15 -17 6 -82 12 -38 29
-79 37 -92 20 -32 12 -47 -27 -50 -55 -4 -97 15 -109 50 -6 17 -11 39 -11 49
0 11 -5 19 -10 19 -15 0 -30 -46 -27 -83 l2 -32 -68 -3 c-37 -2 -74 1 -83 6
-14 8 -14 10 1 25 22 23 84 237 78 270 l-5 27 81 0 c62 0 81 -3 81 -14z m490
-1 c10 -12 10 -23 -2 -53 -19 -50 -51 -56 -67 -12 -9 27 -14 31 -43 28 -27 -3
-33 -8 -40 -37 -11 -39 -4 -50 20 -33 51 36 67 20 45 -44 -15 -45 -45 -60 -57
-29 -10 27 -33 16 -44 -24 -7 -21 -12 -44 -12 -51 0 -21 52 -2 87 32 51 49 78
24 52 -50 -13 -38 -28 -42 -164 -42 -131 0 -147 6 -116 45 11 15 21 35 21 44
0 9 12 52 26 95 14 43 24 90 24 105 -1 14 -2 29 -1 34 1 4 59 7 130 7 102 0
131 -3 141 -15z m201 -67 l42 -83 14 40 c8 22 14 59 14 83 l1 42 43 0 c49 0
67 -16 41 -36 -10 -7 -30 -58 -47 -121 -40 -145 -47 -162 -75 -169 -34 -9 -50
8 -99 105 -27 53 -45 80 -49 71 -20 -57 -35 -130 -30 -144 12 -31 -50 -49 -86
-26 -12 8 -12 11 3 28 22 24 80 229 73 258 -8 30 0 34 61 34 l53 0 41 -82z
m344 72 c3 -5 2 -18 -3 -27 -5 -10 -6 -43 -3 -73 l6 -55 33 44 c34 46 39 70
21 88 -22 22 3 33 76 33 73 0 98 -11 76 -33 -12 -12 -15 -107 -3 -107 4 0 25
29 45 65 25 43 45 67 61 71 55 14 87 -15 70 -63 -8 -24 -15 -28 -48 -28 -38 0
-39 -1 -99 -103 -65 -112 -89 -137 -118 -121 -13 7 -20 27 -25 79 -4 39 -10
72 -14 75 -4 2 -32 -30 -61 -73 -42 -59 -61 -78 -81 -80 -24 -3 -28 1 -37 35
-11 45 -31 175 -31 205 0 12 -7 29 -16 39 -9 10 -13 23 -9 28 8 14 152 15 160
1z m1096 -2224 c-10 -12 -71 -29 -71 -19 0 4 62 31 74 32 5 1 3 -5 -3 -13z
m-176 -86 c-3 -5 -12 -10 -18 -10 -7 0 -6 4 3 10 19 12 23 12 15 0z"/>
<path d="M694 6642 c-17 -11 -39 -60 -58 -124 -22 -76 -21 -108 3 -108 26 0
36 15 66 104 33 99 28 154 -11 128z"/>
<path d="M2562 6623 c-7 -3 -24 -27 -38 -55 l-25 -49 33 3 c29 3 34 8 45 48
13 45 8 61 -15 53z"/>
<path d="M3735 6663 c-57 -15 -95 -72 -95 -143 0 -101 123 -137 193 -57 11 13
14 24 8 30 -10 10 -16 8 -60 -18 -13 -7 -30 -11 -37 -8 -35 13 6 153 44 153
11 0 27 -11 36 -25 22 -34 42 -31 55 6 19 54 15 59 -31 57 -24 -1 -54 1 -68 4
-14 3 -34 4 -45 1z"/>
<path d="M4485 6659 c-38 -11 -55 -34 -55 -76 0 -27 7 -38 43 -64 45 -32 53
-52 25 -57 -10 -2 -31 11 -48 29 -26 29 -32 32 -44 19 -22 -22 -32 -90 -14
-90 8 0 19 5 26 12 9 9 18 9 37 0 65 -30 140 -3 151 53 7 39 -8 63 -58 93 -16
9 -28 24 -28 34 0 25 13 23 48 -7 40 -33 58 -32 66 6 9 48 9 49 -31 46 -21 -1
-49 1 -63 5 -14 3 -38 2 -55 -3z"/>
<path d="M3153 6647 c5 -14 -35 -163 -53 -196 -5 -11 -10 -22 -10 -25 0 -3 44
-6 99 -6 105 0 114 4 126 53 6 22 4 27 -12 27 -11 0 -28 -9 -38 -20 -10 -11
-29 -20 -42 -20 -20 0 -23 3 -17 28 4 15 9 30 11 35 6 11 33 9 33 -3 0 -23 29
-7 39 21 14 41 5 54 -24 35 -28 -19 -35 -13 -26 22 10 38 56 44 65 8 8 -33 34
-33 46 0 20 53 18 54 -96 54 -84 0 -105 -3 -101 -13z"/>
<path d="M3390 6650 c0 -5 4 -10 9 -10 5 0 18 -23 31 -51 l22 -52 -29 -24
c-15 -13 -45 -35 -65 -50 -21 -14 -35 -29 -32 -34 3 -5 27 -9 55 -9 45 0 49 2
49 23 0 13 9 32 20 42 18 17 19 16 25 -7 3 -13 5 -31 3 -39 -2 -11 11 -15 60
-17 34 -2 62 1 62 7 0 5 -11 29 -25 52 -14 24 -25 51 -25 60 0 17 53 70 88 88
36 19 25 31 -28 31 -46 0 -50 -2 -50 -24 0 -13 -7 -27 -16 -30 -21 -8 -26 -3
-26 29 0 24 -3 25 -64 25 -36 0 -64 -4 -64 -10z"/>
<path d="M3923 6645 c7 -16 -39 -184 -54 -199 -5 -6 -9 -14 -9 -18 0 -10 191
-10 207 0 16 10 27 78 14 87 -6 3 -25 -7 -42 -24 -34 -35 -76 -43 -64 -13 3 9
15 49 26 87 10 39 24 72 29 73 6 2 10 8 10 13 0 5 -27 9 -61 9 -49 0 -60 -3
-56 -15z"/>
<path d="M4159 6653 c-1 -5 -1 -12 0 -17 1 -4 -5 -32 -14 -61 -32 -113 -13
-155 71 -155 58 0 95 33 117 103 13 43 23 56 42 61 47 12 43 76 -5 76 -36 0
-39 -5 -70 -105 -23 -72 -28 -80 -53 -83 -23 -3 -27 0 -27 21 0 29 29 129 41
142 5 5 9 13 9 17 0 10 -110 11 -111 1z"/>
<path d="M4683 6645 c7 -16 -39 -184 -54 -199 -19 -20 -7 -26 51 -26 l60 0 0
30 c0 37 36 170 50 184 20 20 9 26 -51 26 -49 0 -60 -3 -56 -15z"/>
<path d="M4825 6643 c4 -10 15 -60 24 -111 28 -143 43 -146 115 -23 42 71 51
80 79 83 28 3 32 7 32 33 0 27 -3 30 -34 30 -31 0 -37 -5 -66 -59 l-33 -58 -7
40 c-4 23 -4 50 0 62 6 19 2 20 -55 20 -55 0 -61 -2 -55 -17z"/>
<path d="M5097 6654 c-3 -3 -3 -12 0 -20 6 -17 -36 -164 -54 -185 -7 -8 -13
-19 -13 -22 0 -4 47 -7 105 -7 93 0 105 2 115 19 27 51 -8 86 -40 41 -8 -11
-25 -20 -38 -20 -21 0 -23 3 -17 28 9 37 22 49 37 34 21 -21 37 -13 44 23 8
45 1 52 -31 31 -27 -18 -30 -12 -15 28 13 34 47 35 60 1 17 -46 50 -26 50 31
0 24 -1 24 -98 24 -54 0 -101 -3 -105 -6z"/>
<path d="M3345 4500 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
